function updateProgressBarColors(progressLevel) {
    const progressIcons = document.querySelectorAll(".rebuy-cart__progress-step-icon");

    progressIcons.forEach(icon => {
        icon.style.backgroundColor = '#d1dbe2';
        icon.querySelector("path").style.fill = "#8494A0";
    });

    for (let i = 0; i < progressLevel; i++) {
        progressIcons[i].style.backgroundColor = '#96c9e6';
        progressIcons[i].querySelector("path").style.fill = "white";
    }
}

function cartChangeHandler(event) {
    const rebuyCart = event.detail.cart.cart;
    const progressBar = document.querySelector(".rebuy-cart__progress-bar-meter");
    const progressBarFill = document.querySelector(".rebuy-cart__progress-bar-meter-fill");
    const progressTextTop = document.querySelector(".rebuy-cart__flyout-shipping-bar-message-before");
    const progressText = document.getElementById("rebuy-text");
    progressBar?.classList.remove("no-progress");

    // Convert cart total to dollars for easier comparison
    const cartValue = rebuyCart.original_total_price / 100;

    if (cartValue >= 400) {
        progressBarFill.style.width = '100%';
        progressTextTop.innerHTML = "<b>15% OFF</b>!";
        progressText.innerHTML = "You've unlocked all available discounts!";
        updateProgressBarColors(3);
    } else if (cartValue >= 300) {
        progressBarFill.style.width = '66%';
        progressTextTop.innerHTML = "<b>10% OFF</b>!";
        progressText.innerHTML = `You are $${(400 - cartValue).toFixed(2)} away from 15% off!`;
        updateProgressBarColors(2);
    } else if (cartValue >= 150) {
        progressBarFill.style.width = '33%';
        progressTextTop.innerHTML = "<b>Free Shipping Unlocked</b>!";
        progressText.innerHTML = `You are $${(300 - cartValue).toFixed(2)} away from 10% off!`;
        updateProgressBarColors(1);
    } else {
        progressBarFill.style.width = '5%';
        progressTextTop.innerHTML = "Keep shopping to unlock discounts!";
        progressText.innerHTML = `You are $${(150 - cartValue).toFixed(2)} away from unlocking the first tier!`;
        updateProgressBarColors(0);
    }
}


document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener('rebuy:cart.ready', (e) => cartChangeHandler(e));
    document.addEventListener('rebuy:cart.change', (e) => cartChangeHandler(e));
});
